export default __webpack_public_path__ + "static/media/die.1e49c6b0.mp3";